import React, { Component } from 'react'
import Dropdown, { DropdownContent, DropdownTrigger } from 'react-simple-dropdown'

import CrossSmallIcon from '../../../assets/icons/cross.svg'

class DeactivateDropdown extends Component {
    constructor(props) {
        super(props);
        this.dropdownRef = React.createRef();
        this.state = {
            rejectionReason: this.props.defaultInput || "Чёрный список"
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    render() {


        return (
            <Dropdown className="dropdown-right dropdown-caret" ref={this.dropdownRef}>
                <DropdownTrigger className="button-icontrigger caption">
                    <span className="icon">
                        {this.props.children}
                    </span>
                    <span>{this.props.triggerText}</span>
                </DropdownTrigger>
                <DropdownContent>
                    <div className="dropdown-content caret">
                        <div className="dropdown-content-data">
                            <p>{this.props.headText}</p>


                        </div>
                        <div className="dropdown-content-data">
                            <div className="form-row-item">
                                <div className="form-element">
                                    <label className="form-element-label" htmlFor="#">Основание для запрета обслуживания</label>
                                    <div className="form-element-data">
                                        <input className="input" type="text" name="rejectionReason" id="rejectionReason"
                                            value={this.state.rejectionReason}
                                            maxLength={this.props.maxLength}
                                            onChange={this.handleInputChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="dropdown-content-actions">


                            {!this.props.hideButton && <div className="dropdown-content-actions-left">
                                <button className="button" onClick={() => {
                                    if (this.props.onAction) {
                                        this.dropdownRef.current.hide()
                                        this.props.onAction(this.state.rejectionReason);
                                    }
                                }}>
                                    <span>
                                        {this.props.buttonText}
                                    </span>
                                </button>
                            </div>}

                            <div className="dropdown-content-actions-right">

                                <button className="button-icontrigger noborder"
                                    onClick={() => {
                                        this.dropdownRef.current.hide()
                                    }}>

                                    <span className="icon">
                                        <CrossSmallIcon />
                                    </span>
                                </button>
                            </div>
                        </div>
                    </div>
                </DropdownContent>
            </Dropdown>
        )
    }
}

export default DeactivateDropdown
